import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ parentcompany, fullcompanylist, accounts, formData, onInputChange }) => {
    const accountOptions = [
        { name: 'Test Account 1' },
        { name: 'Test Account 2' },
        { name: 'Test Account 3' },
    ];
// console.log('lst:',parentcompany);
    return (
      <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                      <label style={{height: '19px'}}></label>
                  <Checkbox
              id="Is_Group_Warehouse"
              label="Is Group Warehouse"
              checked={true}
              value={formData.isGroupWarehouse || false}
              onChange={(checked) => onInputChange("isGroupWarehouse", checked)}
            />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Warehouse Name"
                                label="Warehouse Name"
                                style={{ height: "30px" }}
                                value={formData.warehouseName}
                                onChange={(e) => onInputChange('warehouseName', e.target.value)}
                            />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                list={fullcompanylist || []}
                                label="Company"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.company}
                                onChange={(value) => onInputChange('company', value)}
                                placeholder=""
                            />
                                </div>
                            </div>
                             <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                  <SelectSearch
                                list={parentcompany || []}
                                label="Parent Warehouse"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.parentWarehouse}
                                onChange={(value) => onInputChange('parentWarehouse', value)}
                                placeholder=""

                            />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                list={accounts || []}
                                label="Account"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.account}
                                onChange={(value) => onInputChange('account', value)}
                                placeholder=""
                            />
                                </div>
                                <div style={{ flex: 1 }}>
                                   <Input
                                id="Abbr"
                                label="Abbr"
                                style={{ height: "30px" }}
                                value={formData.abbr}
                                onChange={(e) => onInputChange('abbr', e.target.value)}
                            />
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Warehouse Contact Info</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Phone No."
                                label="Phone No."
                                style={{ height: "30px" }}
                                value={formData.phoneNo}
                                onChange={(e) => onInputChange('phoneNo', e.target.value)}
                            />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Mobile No."
                                label="Mobile No."
                                style={{ height: "30px" }}
                                value={formData.mobileNo}
                                onChange={(e) => onInputChange('mobileNo', e.target.value)}
                            />

                                </div>
                                <div style={{ flex: 1 }}>
                                     <Input
                                id="Address Line 1"
                                label="Address Line 1"
                                style={{ height: "30px" }}
                                value={formData.addressLine1}
                                onChange={(e) => onInputChange('addressLine1', e.target.value)}
                            />
                                </div>
                            </div>

                              <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                   <Input
                                id="Address Line 2"
                                label="Address Line 2"
                                style={{ height: "30px" }}
                                value={formData.addressLine2}
                                onChange={(e) => onInputChange('addressLine2', e.target.value)}
                            />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                id="County"
                                label="County"
                                style={{ height: "30px" }}
                                value={formData.county}
                                onChange={(e) => onInputChange('county', e.target.value)}
                            />

                                </div>
                                <div style={{ flex: 1 }}>
                                     <Input
                                id="State/Province"
                                label="State/Province"
                                style={{ height: "30px" }}
                                value={formData.stateProvince}
                                onChange={(e) => onInputChange('stateProvince', e.target.value)}
                            />
                                </div>
                            </div>
 <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                  <Input
                                id="City/Town"
                                label="City/Town"
                                style={{ height: "30px" }}
                                value={formData.cityTown}
                                onChange={(e) => onInputChange('cityTown', e.target.value)}
                            />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Postal Code"
                                label="Postal Code"
                                style={{ height: "30px" }}
                                value={formData.postalCode}
                                onChange={(e) => onInputChange('postalCode', e.target.value)}
                            />

                                </div>
                                <div style={{ flex: 1 }}>
                                     
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                  <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

            <div className="col-md-12 px-2">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>


                <ActivityCard doctype="Warehouse" docname={formData.warehouseName} />





              </div>
            </div>

          </div>
            </div>

        </div>
    );
};

export default Tab1;